// NOUVEAU FICHIER À CRÉER : frontend/src/services/activityService.js

import api from './api';

const activityService = {
  /**
   * Récupérer les activités avec pagination et filtres
   * @param {Object} params - Paramètres de requête
   * @param {number} params.page - Numéro de page (défaut: 1)
   * @param {number} params.limit - Nombre d'éléments par page (défaut: 20)
   * @param {string} params.action - Filtrer par type d'action (optionnel)
   * @param {string} params.userId - Filtrer par utilisateur (optionnel)
   * @param {string} params.dateFrom - Date de début (optionnel)
   * @param {string} params.dateTo - Date de fin (optionnel)
   * @returns {Promise} Promesse avec la réponse de l'API
   */
  async getActivities(params = {}) {
    try {
      console.log('Service: Récupération des activités avec params:', params);
      
      // Construire les paramètres de requête
      const queryParams = new URLSearchParams();
      
      // Paramètres de pagination
      queryParams.append('page', params.page || 1);
      queryParams.append('limit', params.limit || 20);
      
      // Paramètres de filtrage optionnels
      if (params.action) queryParams.append('action', params.action);
      if (params.userId) queryParams.append('userId', params.userId);
      if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
      if (params.dateTo) queryParams.append('dateTo', params.dateTo);
      
      const response = await api.get(`/dashboard/activities?${queryParams.toString()}`);
      
      console.log('Service: Activités récupérées:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('Erreur service activités:', error);
      
      // Gestion des erreurs spécifiques
      if (error.response?.status === 403) {
        throw new Error('Accès non autorisé - Droits administrateur requis');
      } else if (error.response?.status === 401) {
        throw new Error('Session expirée - Veuillez vous reconnecter');
      } else if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      } else {
        throw new Error('Erreur lors de la récupération des activités');
      }
    }
  },

  /**
   * Récupérer les statistiques des activités
   * @returns {Promise} Promesse avec les statistiques
   */
  async getActivitiesStats() {
    try {
      console.log('Service: Récupération des statistiques d\'activités');
      
      const response = await api.get('/dashboard/activities/stats');
      
      console.log('Service: Statistiques récupérées:', response.data);
      return response.data;
      
    } catch (error) {
      console.error('Erreur service stats activités:', error);
      
      if (error.response?.status === 403) {
        throw new Error('Accès non autorisé - Droits administrateur requis');
      } else if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      } else {
        throw new Error('Erreur lors de la récupération des statistiques');
      }
    }
  },

  /**
   * Obtenir les actions disponibles pour les filtres
   * @returns {Array} Liste des actions disponibles
   */
  getAvailableActions() {
    return [
      { value: 'login', label: 'Connexion' },
      { value: 'logout', label: 'Déconnexion' },
      { value: 'import', label: 'Importation' },
      { value: 'modify', label: 'Modification' },
      { value: 'comment', label: 'Commentaire' },
      { value: 'export', label: 'Exportation' },
      { value: 'user_create', label: 'Création utilisateur' },
      { value: 'user_update', label: 'Modification utilisateur' },
      { value: 'user_delete', label: 'Suppression utilisateur' },
      { value: 'delete_comment', label: 'Suppression commentaire' },
      { value: 'create_scheduled_import', label: 'Création import planifié' },
      { value: 'update_scheduled_import', label: 'Modification import planifié' },
      { value: 'delete_scheduled_import', label: 'Suppression import planifié' },
      { value: 'run_scheduled_import', label: 'Exécution import planifié' },
      { value: 'photo_upload', label: 'Upload photo' },
      { value: 'photo_delete', label: 'Suppression photo' },
      { value: 'photo_set_primary', label: 'Photo principale' },
      { value: 'photo_update_description', label: 'Modification description photo' }
    ];
  }
};

export default activityService;